<template>
  <div>
    <div
      class="text-md font-medium text-white py-2 px-5 rounded mt-4 cursor-pointer flex justify-between"
      v-on:click="show_div = !show_div"
      :class="
        show_div
          ? 'bg-theme-1 text-white'
          : 'bg-white border border-theme-1 text-theme-1 hover:bg-theme-1 hover:text-white'
      "
    >
      <span class="my-auto"
        >{{ show_div ? 'Ocultar' : 'Ver' }} horas por usuario</span
      >
      <span class="font-bold text-lg">{{ show_div ? '-' : '+' }}</span>
    </div>
    <div class="overflow-auto intro-y mt-4" v-if="show_div">
      <table class="w-full mb-4">
        <thead>
          <tr class="intro-x bg-white">
            <th
              class="text-center whitespace-no-wrap p-1 border border-gray-100"
            >
              USUARIO
            </th>
            <th
              class="text-center whitespace-no-wrap p-1 border border-gray-100"
              v-bind:class="item == today ? 'bg-theme-1 text-white' : ''"
              v-for="(item, key) in dates"
              v-bind:key="'headers' + key"
            >
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="intro-x bg-white"
            v-for="(user, index) in users"
            v-bind:key="'hours' + index"
          >
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ user.user }}
              </div>
            </td>
            <td
              v-for="(item, key) in dates"
              v-bind:key="'users' + key"
              class="border border-gray-100"
            >
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                <b
                  class="text-md"
                  :class="user[item] > 0 ? 'text-theme-1' : 'text-gray-400'"
                  >{{ user[item].toFixed(1) }}</b
                >
                / {{ hours_by_today }}
              </div>
            </td>
          </tr>
          <tr class="intro-x bg-white/20">
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
              >
                TOTAL DIA
              </div>
            </td>
            <td
              v-for="(item, key) in dates"
              v-bind:key="'accounts' + key"
              class="border border-gray-100"
            >
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{ users_dates[item].toFixed(1) }} /
                {{ hours_by_today * users.length }}
              </div>
            </td>
          </tr>
          <tr class="intro-x bg-white/20">
            <td class="border border-gray-100">
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
              >
                DISPONIBLES
              </div>
            </td>
            <td
              v-for="(item, key) in dates"
              v-bind:key="'accounts' + key"
              class="border border-gray-100"
              :class="
                hours_by_today * users.length < users_dates[item]
                  ? 'bg-red-200'
                  : hours_by_today * users.length == users_dates[item]
                  ? 'bg-gray-200'
                  : 'bg-green-200'
              "
            >
              <div
                class="text-gray-600 text-xs whitespace-no-wrap text-center p-1"
              >
                {{
                  (hours_by_today * users.length - users_dates[item]).toFixed(1)
                }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dates', 'users', 'users_dates'],
  data() {
    return {
      today: new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'America/Bogota',
      }).format(new Date()),
      hours_by_today: 8.5,
      show_div: false,
    }
  },
}
</script>



// WEBPACK FOOTER //
// HoursUsersPlanning.vue?2b4a0dc0